export enum UpsellPlansModalEnum {
  DOWNGRADE = 'downgrade',
  UPGRADE_ROLLOVER_WARNING = 'upgrade_rollover_warning'
}
